import React, { FC } from 'react';

import { TableCell } from '@material-ui/core';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import { IKImage } from '../../../../../components/IKImage';
import { CellProps } from '../../../const';

const ImageTitleCell: FC<CellProps> = ({ row, k, styles, align }) => {
  const link = row[k]?.link;
  const href = row?.video ? `/${link}/` : `/pathway/${link}/`;
  const image = row?.image;

  return (
    <TableCell key={k} className={styles.contentCell} align={align}>
      <div className={styles.imageCellWithTextWrapper}>
        <IKImage
          className={cx(styles.imageCellContent, styles.imageCellWithText)}
          path={image}
          srcset={[{ width: 50, height: 30 }]}
          sizes="100vw"
        />
        <Link onClick={(e) => e.stopPropagation()} className={styles.tableLink} to={href}>
          {row[k]?.label}
        </Link>
      </div>
    </TableCell>
  );
};

export default ImageTitleCell;
